export default __webpack_public_path__ + "static/blob2-5fbd386d2e7556b26c94eb5cb5d99619.svg";